import { Box, Button } from "@material-ui/core";
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { useStyles } from "./dialog-consultar-contrato-status-styles";
import { useThemeQueries } from "views/theme";
import { CampoContratoStatus } from "./components/campo-contrato-status/campo-contrato-status";
import { useCadastros, useToastSaurus } from "services/app";
import { useState } from "react";
import { CopiarIcon } from "views/components/icons";


interface DialogConsultarContratoStatusProps {
    openned: boolean;
    contratoId: string
}

export const DialogConsultarContratoStatus = ({ openned, contratoId }: DialogConsultarContratoStatusProps) => {
    const classes = useStyles();
    const { isMobile } = useThemeQueries();
    const [jsonResultado, setJsonResultado] = useState('');
    const { showToast } = useToastSaurus();


    const { fecharDialogConsultarContratoStatus } = useCadastros();

    return (
        <DialogSaurus
            titulo="Status do Contrato"
            tamanho="sm"
            aberto={openned}
            isButtonTitleClose
            handleClickClose={fecharDialogConsultarContratoStatus}
            fullScreen={isMobile}
            bottomArea={
                <>
                    {jsonResultado && (
                        <Box width="100%" p={2}>
                            <Button
                                fullWidth
                                onClick={() => {
                                    if (jsonResultado) {
                                        navigator.clipboard.writeText(jsonResultado);
                                    }
                                    showToast('success', 'Copiado')
                                }}
                                variant="contained"
                                color="primary"
                            >
                                <CopiarIcon tipo="BUTTON_PRIMARY" />
                                Copiar
                            </Button>
                        </Box>
                    )}
                </>
            }
        >
            <Box className={classes.container}>
                <CampoContratoStatus
                    contratoId={contratoId}
                    jsonResultado={jsonResultado}
                    setJsonResultado={setJsonResultado}
                />
            </Box>
        </DialogSaurus>
    )
}